export const UI_TOGGLE_DRAWER = 'comn/user/toggle_drawer';
export const UI_TOGGLE_TOAST = 'comn/user/toggle_toast';
export const UI_TOGGLE_RECAPTCHA = 'comn/system/toggle_recaptcha';
export const UI_TOGGLE_SESSION_DIALOG = 'comn/system/toggle_session';
export const UI_TOGGLE_KEYBOARD = 'comn/system/toggle_keyboard';
export const UI_SHOW_ALERT = 'comn/system/toggle_alert';
export const SET_PLATFORM = 'comn/system/set_platform';
export const SET_LANGUAGE = 'comn/system/set_language';
export const SET_EXTENSION_MODE = 'comn/system/set_extension';
export const MAINTENANCE_MODE = 'comn/system/set_maintenanace';
export const COMPARE_TOGGLE_DRAWER = 'comn/user/compare_toggle_drawer';
export const TOGGLE_SIGNUP_MODEL = 'comn/user/toggle_signup_model';
export const SET_THEME = 'comn/system/set_theme';
export const SET_EXPORTED_IMAGES = 'comn/user/set_exported_images';
export const SET_IP_DATA = 'comn/user/set_ip_data';
export const PARAPHRASER_RECEIVED_OTHER_PRODUCT_DATA = 'comn/system/paraphraser_received_other_product_data';
export const SET_SIGN_UP_MODAL_STATE = 'comn/system/set_sign_up_modal_state';
export const SET_COUNTRY_CODE = 'comn/system/set_country_code';
export const SET_INDEPENDENT_TOOL = 'comn/system/set_independent_tool';
export const SET_REGIONAL_LANGUAGE = 'comn/system/set_regional_language';
export const SET_SPAM_CHECK_CALL_STATUS = 'comn/system/set_spam_check_call_status';
export const SET_SIDEBAR_PINNED = 'comn/user/set_sidebar_pinned';
export const SET_PARTNER_COMPANY = 'comn/system/set_partner_company';
export const SET_AB_EXPERIMENTS = 'comn/system/set_ab_experiments';
export const SET_APP_LANGUAGE = 'comn/system/set_app_language';
export const SET_CROSS_PRODUCT_UPSELL = 'comn/system/set_cross_product_upsell';
export const HIDE_SESSION_MANAGER = 'comn/system/hide_session_manager';
export const USER_CLICKED_THEME_BTN = 'comn/user/clicked_theme_btn';
export const USER_CLICKED_LOGOUT_BTN = 'comn/user/clicked_logout_btn';
export const SET_CAMPAIGN = 'comn/system/set_campaign';
